module.exports = __webpack_public_path__ + "static/img/vip-new-window-down.a7da0e12.png";